module.exports = __webpack_public_path__ + "static/media/chat-manager.e9c1c6b0.svg";